import { render, staticRenderFns } from "./CertificateTemplateHelp.vue?vue&type=template&id=68c6b5df&scoped=true"
import script from "./CertificateTemplateHelp.vue?vue&type=script&lang=js"
export * from "./CertificateTemplateHelp.vue?vue&type=script&lang=js"
import style0 from "./CertificateTemplateHelp.vue?vue&type=style&index=0&id=68c6b5df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c6b5df",
  null
  
)

export default component.exports